export default __webpack_public_path__ + "static/media/sales-coach-icon.a043a5ea.svg";